import { Analytics, getAnalytics } from 'firebase/analytics';
import { FirebaseApp, initializeApp } from 'firebase/app';
import _ from 'lodash';
import { BLOG_DOMAINS } from '../../types/blogTypes';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const blogFirebaseConfigDev = {
    apiKey: 'AIzaSyBE5gd3nTriPgbDHhmu7WNUwTJlNuCm6Fk',
    authDomain: 'haewao-blog-dev.firebaseapp.com',
    projectId: 'haewao-blog-dev',
    storageBucket: 'haewao-blog-dev.firebasestorage.app',
    messagingSenderId: '205333648443',
    appId: '1:205333648443:web:2547f8f1fd77b57872381e',
    measurementId: 'G-49Z0FPZ8BZ',
};

const blogFirebaseConfigProd = {
    apiKey: 'AIzaSyCEXRxpNg7ABOqw1VUfEDknYrCfTLMqOVo',
    authDomain: 'haewao-blog-prod.firebaseapp.com',
    projectId: 'haewao-blog-prod',
    storageBucket: 'haewao-blog-prod.firebasestorage.app',
    messagingSenderId: '975548937812',
    appId: '1:975548937812:web:dc1517b2dbda2eb6b59fc1',
    measurementId: 'G-GD75FVDP6Z',
};

const blogFirebaseConfig = import.meta.env.PROD ? blogFirebaseConfigProd : blogFirebaseConfigDev;

class BlogFirebaseStore {
    readonly blogFirebaseApp: FirebaseApp | null = null;
    readonly blogFirebaseAnalytics: Analytics | null = null;

    constructor() {
        // firebase 는 클라이언트에서만 실행해야 함
        if (typeof window === 'undefined') {
            return;
        }

        const hostname = window.location.hostname;
        const domain = _.nth(hostname.split('.'), -2);

        if (!_.includes(BLOG_DOMAINS, domain)) {
            return;
        }

        this.blogFirebaseApp = initializeApp(blogFirebaseConfig);
        this.blogFirebaseAnalytics = getAnalytics(this.blogFirebaseApp);
    }
}

export default new BlogFirebaseStore();
